
const defaultStyles = {
    height: '100vh',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    zIndex: 9999,
}

const Loading = ({styles = {}}) => {
    const finalStyles = {...defaultStyles, ...styles}
    return (
        <div className="Loading" style={finalStyles}>
            <div className="d-flex align-items-center justify-content-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    )
}

export default Loading;